var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5625 29.8259H43.3625V22.1017C43.3625 18.0459 40.0558 14.7392 36 14.7392C31.9442 14.7392 28.6375 18.0459 28.6375 22.1017V29.8259H22.4375V22.1017C22.4375 14.61 28.5342 8.53918 36 8.53918C43.4658 8.53918 49.5625 14.6359 49.5625 22.1017V29.8259Z",
    fill: "#13C097"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5331 28.3274H19.4665C16.6248 28.3274 14.2998 30.6524 14.2998 33.4941V55.7107C14.2998 58.5524 16.6248 60.8774 19.4665 60.8774H52.5331C55.3748 60.8774 57.6998 58.5524 57.6998 55.7107V33.4941C57.6998 30.6524 55.3748 28.3274 52.5331 28.3274ZM38.3248 44.3182V50.0016C38.3248 50.6216 38.0923 51.2157 37.6531 51.6549C37.214 52.0941 36.6198 52.3266 35.9998 52.3266C35.3798 52.3266 34.7856 52.0941 34.3465 51.6549C33.9073 51.2157 33.6748 50.6216 33.6748 50.0016V44.3182C32.9773 43.9049 32.3831 43.3366 31.9698 42.6391C31.5565 41.9416 31.3498 41.1407 31.3498 40.3141C31.3756 39.0999 31.8923 37.9374 32.7448 37.0849C33.6231 36.2324 34.7856 35.7674 35.9998 35.7674C37.214 35.7674 38.3765 36.2324 39.2548 37.0849C40.1331 37.9374 40.624 39.0999 40.6498 40.3141C40.6498 42.0449 39.7198 43.5174 38.3248 44.3182Z",
    fill: "#13C097"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 41,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#2E66F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.125 48.6562L54.2188 52.5625L51.875 50.2188",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckCircle);
export default __webpack_public_path__ + "static/media/ic_check_circle.ede098e0c069fdb8d789977e42fae8b3.svg";
export { ForwardRef as ReactComponent };